export const colors = {
    red: {
        base: "#F0445D"
    }
}
